var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiEdit = function SvgAiEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m6.81 16.524 9.714-9.714c.454-.455.681-.682.803-.927a1.67 1.67 0 0 0 0-1.48c-.122-.245-.349-.472-.803-.927-.455-.454-.682-.681-.927-.803a1.67 1.67 0 0 0-1.48 0c-.245.122-.472.349-.927.803L3.476 13.19c-.481.482-.722.723-.85 1.03-.126.305-.126.646-.126 1.327V17.5h1.953c.68 0 1.021 0 1.328-.127.306-.127.547-.368 1.029-.85M10 17.5h5M12.082 4.582l3.333 3.333"
  })));
};
export default SvgAiEdit;